

import React, { useState, useEffect } from "react";
import { createBank } from "../../../../../services/dashboard/banks";
import { fetchActiveBranches } from "../../../../../services/dashboard/apiServiceDashboard";
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress
} from "@mui/material";


const CreateBankForm = ({ onSuccess }) => {
  const [form, setForm] = useState({
    name: "",
    type: "bank",
    discount_percentage: 0,
    account_number: "",
    root_ids: [],
  });

  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const data = await fetchActiveBranches();
        setBranches(data);
      } catch (err) {
        console.error("فشل في تحميل الفروع.");
      }
    };
    loadBranches();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleRootChange = (e) => {
    setForm({ ...form, root_ids: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const newBank = await createBank({ ...form, root_ids: form.root_ids });
      if (onSuccess) onSuccess(newBank?.data);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
      setOpenConfirm(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 500, margin: "auto" }}>
      <Typography variant="h6" gutterBottom>
        إنشاء حساب جديد
      </Typography>
      <Box component="form" noValidate autoComplete="off" onSubmit={(e) => { e.preventDefault(); setOpenConfirm(true); }}>
        <TextField
          fullWidth
          label="اسم الحساب"
          name="name"
          value={form.name}
          onChange={handleChange}
          margin="normal"
          required
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>نوع الحساب</InputLabel>
          <Select name="type" value={form.type} label="نوع الحساب" onChange={handleChange}>
            <MenuItem value="bank">خزنة</MenuItem>
            <MenuItem value="bank_account">بنك</MenuItem>
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="رقم الحساب"
          name="account_number"
          value={form.account_number}
          onChange={handleChange}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          label="النسبة (%)"
          name="discount_percentage"
          type="number"
          value={form.discount_percentage}
          onChange={handleChange}
          margin="normal"
          required
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>الفروع</InputLabel>
          <Select
            name="root_ids"
            multiple
            value={form.root_ids}
            onChange={handleRootChange}
            renderValue={(selected) => selected.map(id => {
              const match = branches.find(b => b.id === parseInt(id));
              return match ? match.name : id;
            }).join(", ")}
          >
            {branches.map(branch => (
              <MenuItem key={branch.id} value={String(branch.id)}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "إنشاء"}
          </Button>
        </Box>
      </Box>

      {/* Dialog تأكيد الإنشاء */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>تأكيد إنشاء الحساب</DialogTitle>
        <DialogContent>
          <Typography>
            هل أنت متأكد من إنشاء الحساب باسم: <strong>{form.name}</strong>؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>إلغاء</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "تأكيد"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CreateBankForm;
